import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthenticatedRoutes from './masterRoutes/AuthenticatedRoutes';
import UnAuthenticatedRoutes from './masterRoutes/UnAuthenticatedRoutes';
import SnackbarAlert from './shared/snackbarAlert/SnackbarAlert';
import { useSelector } from 'react-redux';
import { SessionContext } from './shared/SessionExpired/SessionContext';
import { injectShowDialog } from './redux/base.config';

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.common)
  const screenRoutes = useSelector((state) => state.common.screenRoutes);

  const { showDialog } = useContext(SessionContext);

  useEffect(() => {
    injectShowDialog(showDialog);
  }, [showDialog]);


  useEffect(() => {
    // if(screenRoutes?.length>0){
      if (Object.keys(userDetails).length > 0 && location.pathname === '/') {
        navigate(screenRoutes[0]?.screenRouteName);
      }
      else if (Object.keys(userDetails).length === 0) {
        if (location.pathname === '/forgotPassword') {
          navigate('/forgotPassword');
        } else {
          navigate('/');
  
        }
    }
   
    // }
  }, [location.pathname, userDetails, navigate,screenRoutes]);

  const getRoutes = () => {
    if (Object.keys(userDetails).length > 0) {
      return <AuthenticatedRoutes />
    }
    if (Object.keys(userDetails).length === 0) {
      return <UnAuthenticatedRoutes />
    }

  }
  return (
    <div className="App">
      {getRoutes()}
      <SnackbarAlert />
    </div>
  )
}

export default App